import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[cellTemplate]',
    standalone: false
})
export class CellTemplateDirective<T> {
  @Input()
  set cellTemplateOf(name: string) {
    this.name = name;
  }

  name: string;

  constructor(public templateRef: TemplateRef<T>) {}
}
